import { EdgeSingular, NodeSingular } from "cytoscape";

import { UIGraphEdge, UIGraphNode } from "../../types/graph";

export const getFullNodeDataFromCytoscape = (
  element: NodeSingular,
): UIGraphNode["data"] => {
  return element.data();
};

export const getNodeDataFromCytoscape = <K extends keyof UIGraphNode["data"]>(
  element: NodeSingular,
  key: K,
): UIGraphNode["data"][K] => {
  return element.data(key);
};

export const getEdgeDataFromCytoscape = <K extends keyof UIGraphEdge["data"]>(
  element: EdgeSingular,
  key: K,
): UIGraphEdge["data"][K] => {
  return element.data(key);
};

export const getFullEdgeDataFromCytoscape = (
  element: EdgeSingular,
): UIGraphEdge["data"] => {
  return element.data();
};
